import readlangClient from "readlangClient";
import * as dateUtils from "shared/dateUtils";

let serverDate;
let clientDate;
let HOUR = 3600 * 1000;

if (window.READLANG.serverTime) {
  serverDate = new Date(window.READLANG.serverTime);
  clientDate = new Date();
}

// 'snaps' the date to the previous hour specified (based on local timezone)
export const getSnapped = async (snapHour): Promise<Date> => {
  const date = await get();
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate() - (date.getHours() < snapHour ? 1 : 0),
    snapHour
  );
};

export const get = async (): Promise<Date> => {
  if (serverDate) {
    const currentClientDate = new Date();
    const timeSinceGet = currentClientDate.getTime() - clientDate.getTime();

    if (timeSinceGet <= 0 || timeSinceGet > HOUR) {
      return await getFromServer();
    } else {
      return new Date(serverDate.getTime() + timeSinceGet);
    }
  } else {
    return await getFromServer();
  }
};

const getFromServer = () =>
  new Promise<Date>((resolve) => {
    readlangClient.request("GET", "/api/currentDate", {}, (response) => {
      if (!response.currentDate) {
        throw "no date in response";
      }

      serverDate = new Date(dateUtils.parse(response.currentDate));
      clientDate = new Date();

      resolve(serverDate);
    });
  });
